<template>
  <div class="lk-wrapper">
    <Account v-if="user.role_id != 3" />
    <AccountShop v-else />  
  </div>
</template>

<script>
import Account from './Account'
import AccountShop from './AccountShop'

import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('auth');

export default {
  components: {
    Account, AccountShop
  },

  computed: {
    ...mapState(['user'])
  }
}
</script>

<style lang="scss">

</style>